import { GetServiceTitanCredentialResponse } from "./types";
import axiosInstance from "../axiosInstance";

export const getServiceTitanCredential = async (
  companyUuid: string,
): Promise<GetServiceTitanCredentialResponse> => {
  const response = await axiosInstance.get<GetServiceTitanCredentialResponse>(
    `/api/private/companies/${companyUuid}/service-titan/credentials`,
  );
  return response.data;
};
